import React from "react";
import { Link } from "react-router-dom";

export default class ElementTabs extends React.Component {
  render() {
    let nav = {
      default: "Основное",
      spare: "Запчасти",
      files: "Файлы",
    };
    if (this.props.manageElement) {
      nav["properties"] = "Свойства";
      nav["maint"] = "ТО";
    }
    if (this.props.element) {
      if (this.props.element.operating) {
        nav["operation"] = "Наработка";
      }
    }
    const { shipId, specId, elementId, mode } = this.props;
    return (
      <ul className="nav nav-tabs mb-4">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/element/${shipId}/${specId}/${elementId}/${id}/`}
              className={` ${
                mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
